import { createWorker } from 'tesseract.js'

export const extractTextFromImage = async image => {
  const worker = await createWorker('eng')

  try {
    const { data: { text } } = await worker.recognize(image)

    return text.trim()
  } finally {
    await worker.terminate()
  }
}
